import * as React from 'react';
import * as ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import 'assets/scss_css/index.scss';
import 'assets/scss_css/index.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store/index'
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';



ReactDOM.render(
  <Router>
    <Provider store={store}>
      <App />
    </Provider>
  </Router>,
  document.getElementById('root')
);

reportWebVitals();
